// Base de datos de animales con sus características
export interface AnimalData {
  emoji: string
  name: string
  size: number // en centímetros
  weight: number // en kilogramos
  danger: number // nivel de peligrosidad 1-10
  speed: number // velocidad máxima en km/h
  lifespan: number // esperanza de vida en años
  intelligence: number // nivel de inteligencia 1-10
}

export const animalDatabase: AnimalData[] = [
  // Insectos y artrópodos (los más pequeños)
  { emoji: '🐜', name: 'Hormiga', size: 0.5, weight: 0.000001, danger: 1, speed: 0.3, lifespan: 0.5, intelligence: 5 },
  { emoji: '🐞', name: 'Mariquita', size: 0.8, weight: 0.00002, danger: 1, speed: 8, lifespan: 1, intelligence: 2 },
  { emoji: '🦟', name: 'Mosquito', size: 0.6, weight: 0.0000025, danger: 4, speed: 2, lifespan: 0.08, intelligence: 1 },
  { emoji: '🪰', name: 'Mosca', size: 0.8, weight: 0.000012, danger: 2, speed: 7, lifespan: 0.08, intelligence: 2 },
  { emoji: '🐝', name: 'Abeja', size: 1.5, weight: 0.0001, danger: 3, speed: 25, lifespan: 0.5, intelligence: 6 },
  { emoji: '🦋', name: 'Mariposa', size: 10, weight: 0.0005, danger: 1, speed: 19, lifespan: 0.3, intelligence: 2 },
  { emoji: '🐛', name: 'Oruga', size: 5, weight: 0.01, danger: 1, speed: 0.5, lifespan: 0.1, intelligence: 1 },
  { emoji: '🪲', name: 'Escarabajo', size: 3, weight: 0.003, danger: 1, speed: 3, lifespan: 1, intelligence: 2 },
  { emoji: '🕷️', name: 'Araña', size: 2, weight: 0.002, danger: 6, speed: 2, lifespan: 2, intelligence: 4 },
  { emoji: '🦂', name: 'Escorpión', size: 10, weight: 0.03, danger: 7, speed: 19, lifespan: 5, intelligence: 2 },
  { emoji: '🦗', name: 'Grillo', size: 3, weight: 0.002, danger: 1, speed: 1, lifespan: 0.3, intelligence: 1 },
  { emoji: '🪳', name: 'Cucaracha', size: 4, weight: 0.003, danger: 1, speed: 5, lifespan: 1, intelligence: 3 },
  
  // Animales muy pequeños
  { emoji: '🐭', name: 'Ratón', size: 10, weight: 0.02, danger: 1, speed: 13, lifespan: 2, intelligence: 6 },
  { emoji: '🐹', name: 'Hámster', size: 15, weight: 0.15, danger: 1, speed: 6, lifespan: 3, intelligence: 4 },
  { emoji: '🐁', name: 'Rata', size: 25, weight: 0.5, danger: 3, speed: 11, lifespan: 3, intelligence: 7 },
  { emoji: '🐀', name: 'Ratón de campo', size: 12, weight: 0.03, danger: 1, speed: 10, lifespan: 2, intelligence: 5 },
  { emoji: '🦎', name: 'Lagartija', size: 8, weight: 0.01, danger: 1, speed: 15, lifespan: 3, intelligence: 2 },
  { emoji: '🐸', name: 'Rana', size: 8, weight: 0.03, danger: 2, speed: 17, lifespan: 5, intelligence: 3 },
  { emoji: '🐢', name: 'Tortuga pequeña', size: 15, weight: 0.5, danger: 1, speed: 0.3, lifespan: 30, intelligence: 4 },
  { emoji: '🦔', name: 'Erizo', size: 20, weight: 0.8, danger: 2, speed: 6, lifespan: 5, intelligence: 5 },
  { emoji: '🦇', name: 'Murciélago', size: 12, weight: 0.015, danger: 2, speed: 40, lifespan: 20, intelligence: 6 },
  { emoji: '🐿️', name: 'Ardilla', size: 28, weight: 0.5, danger: 1, speed: 32, lifespan: 6, intelligence: 7 },
  { emoji: '🦫', name: 'Castor', size: 80, weight: 25, danger: 3, speed: 8, lifespan: 12, intelligence: 8 },
  { emoji: '🦡', name: 'Tejón', size: 75, weight: 12, danger: 5, speed: 30, lifespan: 10, intelligence: 7 },
  
  // Animales pequeño-medianos
  { emoji: '🐰', name: 'Conejo', size: 40, weight: 2, danger: 1, speed: 56, lifespan: 9, intelligence: 5 },
  { emoji: '🐇', name: 'Liebre', size: 50, weight: 4, danger: 1, speed: 72, lifespan: 8, intelligence: 5 },
  { emoji: '🦝', name: 'Mapache', size: 60, weight: 10, danger: 3, speed: 24, lifespan: 3, intelligence: 8 },
  { emoji: '🐱', name: 'Gato', size: 46, weight: 4.5, danger: 2, speed: 48, lifespan: 15, intelligence: 7 },
  { emoji: '🐈', name: 'Gato doméstico', size: 50, weight: 5, danger: 2, speed: 50, lifespan: 18, intelligence: 7 },
  { emoji: '🦨', name: 'Mofeta', size: 55, weight: 3, danger: 4, speed: 16, lifespan: 3, intelligence: 5 },
  { emoji: '🦦', name: 'Nutria', size: 90, weight: 10, danger: 3, speed: 11, lifespan: 15, intelligence: 8 },
  { emoji: '🦘', name: 'Wallaby', size: 90, weight: 20, danger: 3, speed: 48, lifespan: 15, intelligence: 5 },
  
  // Perros y caninos
  { emoji: '🐶', name: 'Perro pequeño', size: 35, weight: 8, danger: 2, speed: 40, lifespan: 15, intelligence: 8 },
  { emoji: '🐕', name: 'Perro mediano', size: 60, weight: 30, danger: 3, speed: 60, lifespan: 13, intelligence: 8 },
  { emoji: '🐩', name: 'Caniche', size: 55, weight: 25, danger: 2, speed: 45, lifespan: 14, intelligence: 9 },
  { emoji: '🦊', name: 'Zorro', size: 70, weight: 7, danger: 4, speed: 50, lifespan: 3, intelligence: 9 },
  { emoji: '🐺', name: 'Lobo', size: 105, weight: 50, danger: 8, speed: 65, lifespan: 13, intelligence: 9 },
  { emoji: '🦮', name: 'Perro guía', size: 65, weight: 35, danger: 2, speed: 55, lifespan: 12, intelligence: 10 },
  
  // Animales medianos
  { emoji: '🐷', name: 'Cerdo', size: 90, weight: 100, danger: 2, speed: 18, lifespan: 20, intelligence: 7 },
  { emoji: '🐖', name: 'Jabalí', size: 110, weight: 80, danger: 7, speed: 48, lifespan: 10, intelligence: 6 },
  { emoji: '🐗', name: 'Jabalí salvaje', size: 120, weight: 150, danger: 8, speed: 45, lifespan: 12, intelligence: 6 },
  { emoji: '🦙', name: 'Llama', size: 180, weight: 150, danger: 3, speed: 56, lifespan: 20, intelligence: 6 },
  { emoji: '🦌', name: 'Ciervo', size: 140, weight: 95, danger: 3, speed: 80, lifespan: 11, intelligence: 5 },
  { emoji: '🐑', name: 'Oveja', size: 100, weight: 80, danger: 1, speed: 24, lifespan: 12, intelligence: 4 },
  { emoji: '🐐', name: 'Cabra', size: 85, weight: 60, danger: 2, speed: 32, lifespan: 15, intelligence: 7 },
  { emoji: '🐪', name: 'Camello', size: 200, weight: 600, danger: 4, speed: 65, lifespan: 50, intelligence: 6 },
  { emoji: '🐫', name: 'Dromedario', size: 210, weight: 500, danger: 4, speed: 64, lifespan: 40, intelligence: 6 },
  { emoji: '🦬', name: 'Bisonte', size: 190, weight: 900, danger: 7, speed: 56, lifespan: 20, intelligence: 5 },
  { emoji: '🐄', name: 'Vaca', size: 150, weight: 700, danger: 2, speed: 40, lifespan: 20, intelligence: 5 },
  { emoji: '🐂', name: 'Toro', size: 160, weight: 1000, danger: 8, speed: 48, lifespan: 18, intelligence: 4 },
  { emoji: '🐃', name: 'Búfalo', size: 170, weight: 800, danger: 7, speed: 56, lifespan: 25, intelligence: 5 },
  
  // Felinos grandes
  { emoji: '🐆', name: 'Guepardo', size: 90, weight: 72, danger: 7, speed: 120, lifespan: 12, intelligence: 7 },
  { emoji: '🐅', name: 'Tigre', size: 110, weight: 220, danger: 9, speed: 65, lifespan: 15, intelligence: 8 },
  { emoji: '🦁', name: 'León', size: 120, weight: 190, danger: 9, speed: 80, lifespan: 14, intelligence: 8 },
  { emoji: '🐯', name: 'Tigre de bengala', size: 115, weight: 260, danger: 10, speed: 60, lifespan: 16, intelligence: 8 },
  { emoji: '🦊', name: 'Leopardo', size: 100, weight: 70, danger: 8, speed: 58, lifespan: 17, intelligence: 8 },
  { emoji: '🐆', name: 'Jaguar', size: 95, weight: 100, danger: 9, speed: 80, lifespan: 15, intelligence: 7 },
  { emoji: '🦁', name: 'Puma', size: 90, weight: 68, danger: 8, speed: 80, lifespan: 13, intelligence: 7 },
  
  // Osos y grandes carnívoros
  { emoji: '🐻', name: 'Oso pardo', size: 200, weight: 400, danger: 9, speed: 55, lifespan: 25, intelligence: 8 },
  { emoji: '🐻‍❄️', name: 'Oso polar', size: 250, weight: 600, danger: 10, speed: 40, lifespan: 30, intelligence: 7 },
  { emoji: '🐼', name: 'Oso panda', size: 150, weight: 120, danger: 6, speed: 32, lifespan: 20, intelligence: 7 },
  
  // Primates
  { emoji: '🐵', name: 'Mono pequeño', size: 35, weight: 1.5, danger: 3, speed: 35, lifespan: 15, intelligence: 8 },
  { emoji: '🐒', name: 'Mono mediano', size: 55, weight: 8, danger: 4, speed: 40, lifespan: 25, intelligence: 8 },
  { emoji: '🦍', name: 'Gorila', size: 175, weight: 220, danger: 7, speed: 32, lifespan: 40, intelligence: 10 },
  { emoji: '🦧', name: 'Orangután', size: 140, weight: 90, danger: 6, speed: 5, lifespan: 45, intelligence: 10 },
  { emoji: '🐕‍🦺', name: 'Chimpancé', size: 120, weight: 60, danger: 7, speed: 40, lifespan: 50, intelligence: 10 },
  
  // Marsupiales
  { emoji: '🦘', name: 'Canguro', size: 160, weight: 85, danger: 5, speed: 70, lifespan: 23, intelligence: 6 },
  { emoji: '🐨', name: 'Koala', size: 85, weight: 12, danger: 2, speed: 30, lifespan: 13, intelligence: 6 },
  
  // Équidos
  { emoji: '🐴', name: 'Caballo', size: 175, weight: 450, danger: 3, speed: 88, lifespan: 30, intelligence: 7 },
  { emoji: '🐎', name: 'Caballo de carrera', size: 165, weight: 500, danger: 3, speed: 70, lifespan: 25, intelligence: 7 },
  { emoji: '🦓', name: 'Cebra', size: 145, weight: 350, danger: 5, speed: 65, lifespan: 25, intelligence: 6 },
  { emoji: '🦄', name: 'Unicornio', size: 180, weight: 500, danger: 3, speed: 100, lifespan: 1000, intelligence: 10 },
  
  // Megafauna africana
  { emoji: '🦒', name: 'Jirafa', size: 550, weight: 1200, danger: 4, speed: 60, lifespan: 25, intelligence: 6 },
  { emoji: '🐘', name: 'Elefante africano', size: 400, weight: 6000, danger: 7, speed: 40, lifespan: 70, intelligence: 10 },
  { emoji: '🦏', name: 'Rinoceronte', size: 380, weight: 2300, danger: 8, speed: 55, lifespan: 45, intelligence: 6 },
  { emoji: '🦛', name: 'Hipopótamo', size: 350, weight: 3500, danger: 9, speed: 48, lifespan: 40, intelligence: 6 },
  
  // Reptiles
  { emoji: '🐊', name: 'Cocodrilo', size: 400, weight: 450, danger: 9, speed: 35, lifespan: 70, intelligence: 5 },
  { emoji: '🐍', name: 'Serpiente', size: 180, weight: 10, danger: 7, speed: 19, lifespan: 20, intelligence: 4 },
  { emoji: '🦎', name: 'Lagarto', size: 25, weight: 0.5, danger: 2, speed: 29, lifespan: 5, intelligence: 3 },
  { emoji: '🐢', name: 'Tortuga marina', size: 120, weight: 150, danger: 2, speed: 35, lifespan: 100, intelligence: 5 },
  { emoji: '🐲', name: 'Dragón de Komodo', size: 250, weight: 90, danger: 9, speed: 20, lifespan: 30, intelligence: 5 },
  
  // Aves pequeñas
  { emoji: '🐦', name: 'Gorrión', size: 15, weight: 0.03, danger: 1, speed: 40, lifespan: 3, intelligence: 6 },
  { emoji: '🐤', name: 'Pollito', size: 10, weight: 0.05, danger: 1, speed: 5, lifespan: 0.1, intelligence: 2 },
  { emoji: '🐥', name: 'Pato bebé', size: 12, weight: 0.08, danger: 1, speed: 3, lifespan: 0.2, intelligence: 3 },
  { emoji: '🐣', name: 'Pájaro recién nacido', size: 5, weight: 0.02, danger: 1, speed: 0, lifespan: 0.05, intelligence: 1 },
  { emoji: '🕊️', name: 'Paloma', size: 30, weight: 0.4, danger: 1, speed: 75, lifespan: 6, intelligence: 6 },
  { emoji: '🦜', name: 'Loro', size: 40, weight: 1, danger: 2, speed: 56, lifespan: 60, intelligence: 9 },
  { emoji: '🦚', name: 'Pavo real', size: 100, weight: 5, danger: 2, speed: 16, lifespan: 20, intelligence: 5 },
  { emoji: '🦉', name: 'Búho', size: 50, weight: 2, danger: 4, speed: 65, lifespan: 10, intelligence: 8 },
  
  // Aves medianas
  { emoji: '🦆', name: 'Pato', size: 50, weight: 1.5, danger: 1, speed: 100, lifespan: 10, intelligence: 5 },
  { emoji: '🦢', name: 'Cisne', size: 150, weight: 15, danger: 4, speed: 88, lifespan: 20, intelligence: 6 },
  { emoji: '🦩', name: 'Flamenco', size: 145, weight: 3.5, danger: 2, speed: 60, lifespan: 40, intelligence: 5 },
  { emoji: '🐧', name: 'Pingüino', size: 110, weight: 35, danger: 2, speed: 36, lifespan: 20, intelligence: 7 },
  { emoji: '🐓', name: 'Gallo', size: 50, weight: 3, danger: 2, speed: 15, lifespan: 8, intelligence: 4 },
  { emoji: '🦃', name: 'Pavo', size: 100, weight: 10, danger: 2, speed: 40, lifespan: 10, intelligence: 4 },
  
  // Aves rapaces
  { emoji: '🦅', name: 'Águila', size: 90, weight: 6, danger: 6, speed: 160, lifespan: 20, intelligence: 8 },
  { emoji: '🦆', name: 'Halcón', size: 55, weight: 1.2, danger: 5, speed: 240, lifespan: 15, intelligence: 8 },
  { emoji: '🦉', name: 'Lechuza', size: 45, weight: 1.5, danger: 4, speed: 60, lifespan: 12, intelligence: 8 },
  
  // Animales marinos pequeños
  { emoji: '🐟', name: 'Pececillo', size: 8, weight: 0.01, danger: 1, speed: 8, lifespan: 2, intelligence: 2 },
  { emoji: '🐠', name: 'Pez tropical', size: 12, weight: 0.03, danger: 1, speed: 10, lifespan: 5, intelligence: 2 },
  { emoji: '🐡', name: 'Pez globo', size: 30, weight: 1.2, danger: 6, speed: 5, lifespan: 10, intelligence: 3 },
  { emoji: '🦐', name: 'Camarón', size: 10, weight: 0.05, danger: 1, speed: 12, lifespan: 2, intelligence: 1 },
  { emoji: '🦑', name: 'Calamar', size: 60, weight: 2, danger: 3, speed: 40, lifespan: 2, intelligence: 7 },
  { emoji: '🐙', name: 'Pulpo', size: 90, weight: 15, danger: 5, speed: 40, lifespan: 4, intelligence: 10 },
  { emoji: '🦀', name: 'Cangrejo', size: 20, weight: 0.5, danger: 2, speed: 3, lifespan: 3, intelligence: 3 },
  { emoji: '🦞', name: 'Langosta', size: 50, weight: 1, danger: 2, speed: 8, lifespan: 50, intelligence: 3 },
  { emoji: '🐚', name: 'Almeja', size: 10, weight: 0.2, danger: 1, speed: 0, lifespan: 100, intelligence: 1 },
  
  // Animales marinos medianos
  { emoji: '🐠', name: 'Pez payaso', size: 11, weight: 0.025, danger: 1, speed: 8, lifespan: 10, intelligence: 3 },
  { emoji: '🦭', name: 'Foca', size: 180, weight: 130, danger: 3, speed: 40, lifespan: 30, intelligence: 7 },
  { emoji: '🦈', name: 'Tiburón blanco', size: 400, weight: 520, danger: 9, speed: 50, lifespan: 30, intelligence: 6 },
  { emoji: '🐬', name: 'Delfín', size: 250, weight: 200, danger: 4, speed: 60, lifespan: 45, intelligence: 10 },
  { emoji: '🐋', name: 'Orca', size: 800, weight: 5000, danger: 9, speed: 56, lifespan: 90, intelligence: 10 },
  { emoji: '🐳', name: 'Ballena azul', size: 2500, weight: 150000, danger: 6, speed: 48, lifespan: 90, intelligence: 9 },
  { emoji: '🦑', name: 'Calamar gigante', size: 1200, weight: 275, danger: 7, speed: 45, lifespan: 5, intelligence: 8 },
  
  // Anfibios
  { emoji: '🐸', name: 'Rana común', size: 8, weight: 0.03, danger: 2, speed: 17, lifespan: 5, intelligence: 3 },
  { emoji: '🐢', name: 'Sapo', size: 12, weight: 0.1, danger: 2, speed: 5, lifespan: 10, intelligence: 3 },
  { emoji: '🦎', name: 'Salamandra', size: 15, weight: 0.05, danger: 2, speed: 8, lifespan: 15, intelligence: 3 },
  
  // Dinosaurios y criaturas prehistóricas
  { emoji: '🦖', name: 'Tiranosaurio Rex', size: 1200, weight: 8000, danger: 10, speed: 45, lifespan: 30, intelligence: 5 },
  { emoji: '🦕', name: 'Brontosaurio', size: 2200, weight: 15000, danger: 5, speed: 15, lifespan: 80, intelligence: 3 },
  { emoji: '🐉', name: 'Dragón', size: 1500, weight: 5000, danger: 10, speed: 150, lifespan: 1000, intelligence: 10 },
  { emoji: '🦴', name: 'Mamut', size: 420, weight: 7000, danger: 6, speed: 32, lifespan: 60, intelligence: 8 },
]

export type CategoryType = 'size' | 'weight' | 'danger' | 'speed' | 'lifespan' | 'intelligence'

export interface Category {
  id: CategoryType
  name: string
  emoji: string
  unit: string
  description: string
}

export const categories: Category[] = [
  { 
    id: 'size', 
    name: 'Tamaño', 
    emoji: '📏', 
    unit: 'cm',
    description: 'Ordena por altura/longitud'
  },
  { 
    id: 'weight', 
    name: 'Peso', 
    emoji: '⚖️', 
    unit: 'kg',
    description: 'Ordena por peso corporal'
  },
  { 
    id: 'danger', 
    name: 'Peligrosidad', 
    emoji: '⚠️', 
    unit: '/10',
    description: 'Ordena por nivel de peligro'
  },
  { 
    id: 'speed', 
    name: 'Velocidad', 
    emoji: '⚡', 
    unit: 'km/h',
    description: 'Ordena por velocidad máxima'
  },
  { 
    id: 'lifespan', 
    name: 'Longevidad', 
    emoji: '🕰️', 
    unit: 'años',
    description: 'Ordena por esperanza de vida'
  },
  { 
    id: 'intelligence', 
    name: 'Inteligencia', 
    emoji: '🧠', 
    unit: '/10',
    description: 'Ordena por nivel de inteligencia'
  },
]

// Obtener animales aleatorios
export const getRandomAnimals = (count: number, exclude: string[] = []): AnimalData[] => {
  const available = animalDatabase.filter(a => !exclude.includes(a.emoji))
  const shuffled = [...available].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

// Obtener valor de una categoría
export const getAnimalValue = (animal: AnimalData, category: CategoryType): number => {
  return animal[category]
}

// Formatear valor para mostrar
export const formatValue = (value: number, category: CategoryType): string => {
  if (category === 'weight') {
    if (value < 0.001) return `${(value * 1000000).toFixed(0)} mg`
    if (value < 1) return `${(value * 1000).toFixed(0)} g`
    if (value >= 1000) return `${(value / 1000).toFixed(1)} ton`
    return `${value.toFixed(1)} kg`
  }
  if (category === 'size') {
    if (value >= 100) return `${(value / 100).toFixed(1)} m`
    return `${value} cm`
  }
  if (category === 'lifespan') {
    if (value < 1) return `${(value * 12).toFixed(0)} meses`
    return `${value} años`
  }
  const cat = categories.find(c => c.id === category)
  return `${value}${cat?.unit || ''}`
}

// Obtener todos los animales ordenados por categoría
export const getAnimalsSortedBy = (category: CategoryType): AnimalData[] => {
  return [...animalDatabase].sort((a, b) => 
    getAnimalValue(a, category) - getAnimalValue(b, category)
  )
}

// Obtener dato curioso sobre un animal
export const getAnimalFact = (animal: AnimalData, category: CategoryType): string => {
  const value = getAnimalValue(animal, category)
  const formattedValue = formatValue(value, category)
  
  const facts: Record<CategoryType, string> = {
    size: `El ${animal.name} mide ${formattedValue} de altura/longitud`,
    weight: `El ${animal.name} pesa ${formattedValue}`,
    danger: `El ${animal.name} tiene un nivel de peligrosidad de ${value}/10`,
    speed: `El ${animal.name} puede alcanzar hasta ${value} km/h`,
    lifespan: `El ${animal.name} vive aproximadamente ${formattedValue}`,
    intelligence: `El ${animal.name} tiene una inteligencia de ${value}/10`
  }
  
  return facts[category]
}

// Comparar dos animales
export const compareAnimals = (animal1: AnimalData, animal2: AnimalData, category: CategoryType): string => {
  const val1 = getAnimalValue(animal1, category)
  const val2 = getAnimalValue(animal2, category)
  const diff = Math.abs(val1 - val2)
  const bigger = val1 > val2 ? animal1.name : animal2.name
  const smaller = val1 < val2 ? animal1.name : animal2.name
  
  if (category === 'weight') {
    if (val1 === val2) return `${animal1.name} y ${animal2.name} pesan lo mismo`
    const times = (Math.max(val1, val2) / Math.min(val1, val2)).toFixed(1)
    return `${bigger} pesa ${times}× más que ${smaller}`
  }
  
  if (category === 'size') {
    if (val1 === val2) return `${animal1.name} y ${animal2.name} miden lo mismo`
    const times = (Math.max(val1, val2) / Math.min(val1, val2)).toFixed(1)
    return `${bigger} es ${times}× más grande que ${smaller}`
  }
  
  if (category === 'speed') {
    if (val1 === val2) return `${animal1.name} y ${animal2.name} van igual de rápido`
    return `${bigger} es ${diff} km/h más rápido que ${smaller}`
  }
  
  if (category === 'lifespan') {
    if (val1 === val2) return `${animal1.name} y ${animal2.name} viven lo mismo`
    return `${bigger} vive ${diff} años más que ${smaller}`
  }
  
  if (category === 'intelligence' || category === 'danger') {
    if (val1 === val2) return `${animal1.name} y ${animal2.name} tienen el mismo nivel`
    return `${bigger} tiene ${diff} puntos más que ${smaller}`
  }
  
  return ''
}
